export class OrgCostDataFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "EonAccountIdFilters",
            "format": ""
        },
        {
            "name": "product",
            "baseName": "product",
            "type": "CostProductFilters",
            "format": ""
        },
        {
            "name": "usageType",
            "baseName": "usageType",
            "type": "UsageTypeFilters",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "CloudAccountIdFilters",
            "format": ""
        },
        {
            "name": "sourceAccountProviderId",
            "baseName": "sourceAccountProviderId",
            "type": "SourceAccountProviderIdFilters",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "CloudProviderFilters",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceTypeFilters",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "tagKeys",
            "baseName": "tagKeys",
            "type": "TagKeysFilters",
            "format": ""
        },
        {
            "name": "tagKeyValues",
            "baseName": "tagKeyValues",
            "type": "TagKeyValuesFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OrgCostDataFilters.attributeTypeMap;
    }
    constructor() {
    }
}
